import { apiRequest } from "../utils/config/apiRequest"
import { apiUrl } from "../utils/endPoints/apiUrl"



export const fetchNotification = async()=>{
  try{
    const response = await apiRequest({
      endUrl : apiUrl.notifications.notification,
      method: "GET",
    })
    if(response.status === true){
      return{
          success: true,
          data: response.data,
      }
      }else{
        throw new Error(response.message || "Failed");
      }
  }catch(error){
    console.error("Error in Creating User:", error);
    return { success: false, error: error.message };
  }
}

export const markNotificationRead = async (notificationId) => {
  try {
    const response = await apiRequest({
      endUrl: `${apiUrl.notifications.notification}/${notificationId}`,
      method: "PATCH",
    });

    if (response.status === true) {
      return {
        success: true,
        data: response.data,
      };
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const markAllNotificationsRead = async () => {
  try {
    const response = await apiRequest({
      endUrl: `${apiUrl.notifications.markAllRead}`,
      method: "PATCH",
    });

    if (response.status === true) {
      return {
        success: true,
        data: response.data,
      };
    } else {
      throw new Error(response.message || "Failed to mark all as read");
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};
